import React, { lazy, Suspense } from "react";
import { Settings } from "./Settings.tsx";
import { ChartPreviewPlaceholder } from "./ChartPreviewPlaceholder.tsx";
import { useCanPreviewPdf } from '../Shared/Pdf/useCanPreviewPdf.ts';
import { DefaultSettings } from "./Models.ts";
import { SettingsContext } from "./SettingsContext.tsx";
import { Seo } from "../Shared/Seo/Seo.tsx";
import { findBySlug } from "../Shared/Seo/routeSeo.ts";
import { useTranslation } from "../Shared/i18n/useTranslation.ts";

// Loaded on demand; see WorksheetPreview for why.
const ChartPreview = lazy(() => import("./PdfGenerator/ChartPreview.tsx"));


export function MultiplicationChart() {
    const [settings, setSettings] = React.useState(DefaultSettings);
    const entry = findBySlug("/multiplication-chart")!;
    settings.IsMultiplicationChart = true;
    const t = useTranslation();


    const canPreview = useCanPreviewPdf();
    return (
        <SettingsContext.Provider value={{settings, setSettings}}>
            <div>                
                <Seo entry={entry}/>
                <h1>{entry.h1}</h1>
                {entry.intro?.map((paragraph, i) => (
                    <p key={i} className="chartIntro">{paragraph}</p>
                ))}          
                <Settings/>
                <Suspense fallback={<ChartPreviewPlaceholder canPreview={canPreview} buildingLabel={t('charts.buildingChart')}/>}>
                    <ChartPreview
                        settings={settings}
                        title={'Multiplication Chart'}
                        canPreview={canPreview}
                        fileName={'multiplication-chart.pdf'}
                    />
                </Suspense>
                {/* The FAQ is in the prerendered page and in the page's FAQ
                    structured data, so it has to be on the rendered page too:
                    Google only honours FAQ markup for questions a visitor can
                    read there (ADR 0067). */}
                {entry.faq && entry.faq.length > 0 && (
                    <section className="landingFaq">
                        <h2>{t('settings.frequentlyAskedQuestions')}</h2>
                        {entry.faq.map((item, i) => (
                            <div key={i} className="faqItem">
                                <h3>{item.q}</h3>
                                <p>{item.a}</p>
                            </div>
                        ))}
                    </section>
                )}
            </div>
        </SettingsContext.Provider>
    );

}